export function HxSkeleton({ height = 44, count = 1, gap = 10, style }) {
  return (
    <div style={{ display: "grid", gap, ...style }}>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="hx-skel" style={{ height }} />
      ))}
    </div>
  );
}
